import RedirectingSearchBarWithAboutBanner from './RedirectingSearchBarWithAboutBanner';

export default RedirectingSearchBarWithAboutBanner;
